import { cn } from "@/lib/utils";

type ChipVariant = "primary" | "neutral";

const VARIANT_CLASSES: Record<ChipVariant, string> = {
  primary: "bg-primary/10 text-primary border-primary/10",
  neutral: "bg-background text-foreground border-border shadow-sm",
};

interface ProfileChipProps {
  children: React.ReactNode;
  variant?: ChipVariant;
  className?: string;
}

export function ProfileChip({ children, variant = "primary", className }: ProfileChipProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border px-2 py-1 text-xs font-medium",
        VARIANT_CLASSES[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
